import React, { FC, Fragment } from 'react';

import { Button } from '@mui/material';

import styles from './ContextCreationView.module.scss';

interface ContextCreationViewProps {
  powerplantName: string;
  onCreate: (powerplantName: string) => void;
}

export const ContextCreationView: FC<ContextCreationViewProps> = (
  {
    powerplantName,
    onCreate,
  }
) => {
  return (
    <div
      className={styles.ContextCreationView}
      data-testid="ContextCreationView"
    >
      <Fragment>
        <div>Powerplant {powerplantName} has no model yet.</div>
        <Button
          variant={'contained'}
          onClick={() => onCreate(powerplantName)}
        >
          Click here
        </Button>
        <div>to create one</div>
      </Fragment>
    </div>
  );
}

export default ContextCreationView;
